import React, { useState } from "react";

const Faqs = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const sectionStyle = {
    padding: "100px 20px",
    background: "linear-gradient(135deg, #f6fbff 0%, #e8f3ff 100%)",
    fontFamily: "'Poppins', sans-serif",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "60px",
  };

  const leftStyle = {
    flex: "1",
    minWidth: "300px",
    maxWidth: "500px",
    textAlign: "left",
  };

  const headingStyle = {
    fontSize: "42px",
    fontWeight: "800",
    color: "#002b5c",
    marginBottom: "20px",
    lineHeight: "1.2",
  };

  const highlight = { color: "#ffcb24" };

  const subheadingStyle = {
    fontSize: "18px",
    color: "#555",
    lineHeight: "1.8",
    marginBottom: "40px",
  };

  const rightStyle = {
    flex: "1",
    minWidth: "300px",
    maxWidth: "600px",
  };

  const faqItem = {
    background: "white",
    borderRadius: "12px",
    marginBottom: "15px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
    overflow: "hidden",
    transition: "all 0.3s ease",
  };

  const questionStyle = (isActive) => ({
    padding: "20px 25px",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "18px",
    fontWeight: "600",
    color: isActive ? "#ffcb24" : "#1e293b",
    transition: "color 0.3s ease",
  });

  const iconStyle = (isActive) => ({
    fontSize: "28px",
    fontWeight: "bold",
    transform: isActive ? "rotate(45deg)" : "rotate(0deg)",
    color: isActive ? "#0d6efd" : "#999",
    transition: "transform 0.3s ease, color 0.3s ease",
  });

  const answerStyle = (isActive) => ({
    maxHeight: isActive ? "400px" : "0px",
    overflow: "hidden",
    transition: "max-height 0.4s ease, opacity 0.3s ease",
    opacity: isActive ? 1 : 0,
    padding: isActive ? "0 25px 20px" : "0 25px",
    fontSize: "16px",
    color: "#555",
    lineHeight: "1.8",
  });

  const faqs = [
    {
      question: "How can I book an appointment online?",
      answer:
        "You can easily book an appointment by searching for a doctor, choosing your preferred time slot, and confirming the booking. You’ll receive a confirmation message instantly.",
    },
    {
      question: "Is my personal health data secure?",
      answer:
        "Yes. We use end-to-end encryption and advanced security measures to protect all your personal and medical data.",
    },
    {
      question: "Can I reschedule or cancel an appointment?",
      answer:
        "Absolutely. You can reschedule or cancel your appointment anytime through your dashboard with just a click.",
    },
    {
      question: "Do I need to pay online for my appointment?",
      answer:
        "We offer both online payment and pay-at-clinic options. Online transactions are secure and encrypted.",
    },
    {
      question: "Can I consult with a doctor virtually?",
      answer:
        "Yes, we offer secure online consultations with top doctors, so you can get medical advice from anywhere.",
    },
  ];

  return (
    <section style={sectionStyle}>
      {/* LEFT SIDE */}
      <div style={leftStyle}>
        <h2 style={headingStyle}>
          Frequently Asked <span style={highlight}>Questions</span>
        </h2>
        <p style={subheadingStyle}>
          We know you may have questions about booking, consultations, and security.
          Here are the answers to the most common ones — quick, clear, and simple.
        </p>
        {/* <img
          src="https://images.unsplash.com/photo-1588776814546-1c3a8f0c801e?auto=format&fit=crop&w=600&q=80"
          alt="FAQ Illustration"
          style={{
            width: "100%",
            borderRadius: "15px",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
          }}
        /> */}
      </div>

      {/* RIGHT SIDE */}
      <div style={rightStyle}>
        {faqs.map((faq, index) => {
          const isActive = activeIndex === index;
          return (
            <div key={index} style={faqItem}>
              <div
                style={questionStyle(isActive)}
                onClick={() => setActiveIndex(isActive ? null : index)}
              >
                {faq.question}
                <span style={iconStyle(isActive)}>+</span>
              </div>
              <div style={answerStyle(isActive)}>
                <p>{faq.answer}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Faqs;
